import classNames from 'classnames';

const SidebarSeparator = ({ className }: { className?: string }) => {
  return (
    <hr className={classNames("border-eggplant-lightest/30 m-0", className)} />
  );
};

export default SidebarSeparator;
